import { GridCellProps } from "@progress/kendo-react-grid/dist/npm/interfaces/GridCellProps";
import { MaskedTextBox, MaskedTextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { useEffect, useState } from "react";
import { FtlRoutingViewModelStopDataKey } from "../../../../ViewModel/FtlRoutingViewModel";

type Props = {
  gridCellProps: GridCellProps;
  isEditable: boolean;
  ftlRoutingViewModelStopDataKey: FtlRoutingViewModelStopDataKey;
  isDrivingHour?: boolean | undefined;
};

const MaskedHourMinuteWithSeparatorGridCell = ({
  gridCellProps,
  isEditable,
  ftlRoutingViewModelStopDataKey,
  isDrivingHour = false,
}: Props) => {
  const {
    onChange,
    dataItem,
    dataIndex,
    field,
    colSpan,
    ariaColumnIndex,
    isSelected,
    columnIndex,
  } = gridCellProps;

  const [maskedInput, setMaskedInput] = useState<string>(
    dataItem?.[ftlRoutingViewModelStopDataKey] ?? ""
  );
  const [maskedChangeEvent, setMaskedChangeEvent] = useState<MaskedTextBoxChangeEvent | undefined>(
    undefined
  );

  const hourMinuteFormatWithTwoDigitsHour = /^((0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]|N\/A)$|^$/;
  const drivingHoursFormatWithTwoDigitsHour = /^[0-9][0-9]:[0-5][0-9]$|N\/A$|^$/;
  const maskedInputMatches = maskedInput.match(
    isDrivingHour ? drivingHoursFormatWithTwoDigitsHour : hourMinuteFormatWithTwoDigitsHour
  );

  useEffect(() => {
    if (maskedInputMatches && onChange && maskedChangeEvent) {
      onChange({
        value: maskedInput,
        field,
        dataItem,
        dataIndex,
        syntheticEvent: maskedChangeEvent.syntheticEvent,
      });
    }
  }, [maskedInput, maskedChangeEvent]);

  const filterCellMask = "00:00";

  return (
    <td
      colSpan={colSpan}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      aria-disabled={isEditable}
    >
      <MaskedTextBox
        style={{
          borderColor: maskedInputMatches ? undefined : isEditable ? "red" : undefined,
          opacity: 1,
          backgroundColor: isEditable ? undefined : "transparent",
          border: isEditable ? undefined : "none",
        }}
        mask={filterCellMask}
        defaultValue={filterCellMask}
        value={maskedInput}
        onChange={(event: MaskedTextBoxChangeEvent) => {
          setMaskedInput(event.value);
          setMaskedChangeEvent(event);
        }}
        disabled={!isEditable}
      />
    </td>
  );
};

export const maskedHourMinuteWithSeparatorGridCell = ({
  gridCellProps,
  isEditable,
  ftlRoutingViewModelStopDataKey,
  isDrivingHour,
}: Props) => (
  <MaskedHourMinuteWithSeparatorGridCell
    gridCellProps={gridCellProps}
    isEditable={isEditable}
    ftlRoutingViewModelStopDataKey={ftlRoutingViewModelStopDataKey}
    isDrivingHour={isDrivingHour}
  />
);
